import React from 'react';
import ActivateObject from '../../../common/poppers/ActivateObject';
import DeleteObject from '../../../common/poppers/DeleteObject';
import CategoryRow from './CategoryRow';
import ModifyCategory from './ModifyCategory';
import EditIcon from '@material-ui/icons/Edit';
import CancelOutlinedIcon from '@material-ui/icons/CancelOutlined';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import DeleteIcon from '@material-ui/icons/Delete';

export const categoryActionItems = [
    {
        dataDialog: "modify-dialog",
        title: "Módosít",
        dialogTitle: "Költségviselő módosítása",
        icon: <EditIcon fontSize="small" color="primary" />,
        actionComponent: (props, close) => <ModifyCategory {...props} close={close} />
    },
    {
        dataDialog: "active-dialog",
        title: "Aktiválás",
        dialogTitle: "Költségviselő aktiválása",
        icon: <CheckCircleOutlineIcon fontSize="small" color="primary" />,
        canShow: (row) => !row.active,
        actionComponent: (props, close) => <ActivateObject {...props} close={close} path={'/api/activatecategory'} comp={<CategoryRow {...props} />} />
    },
    {
        dataDialog: "active-dialog",
        title: "Inaktiválás",
        dialogTitle: "Költségviselő inaktiválása",
        icon: <CancelOutlinedIcon fontSize="small" color="primary" />,
        canShow: (row) => row.active,
        actionComponent: (props, close) => <ActivateObject {...props} close={close} path={'/api/activatecategory'} inactive={true} comp={<CategoryRow {...props} />} />
    },
    {
        divider: true,
    },
    {
        dataDialog: "delete-dialog",
        title: "Törlés",
        dialogTitle: "Költségviselő törlése",
        icon: <DeleteIcon fontSize="small" color="primary" />,
        actionComponent: (props, close) => <DeleteObject {...props} close={close} path={'/api/category'} comp={<CategoryRow {...props} />} />
    },
];